export default {
  methods: {
    downloadCsv(fileName, items) {
      console.dir(items);
      const LF = '\n';
      const BOM = '\ufeff';
      let csv = BOM;

      items.forEach((el) => {
        let line = '';
        el.forEach((data) => {
          // null undefinedの場合は空文字
          data = data === null ? '' : data;
          data = data === undefined ? '' : data;
          data = String(data);
          data = data.replace('"', '""');
          line += `"${data}",`;
        });
        line = line.slice(0, -1); // 末尾のカンマは不要
        csv += line + LF;
      });
      let blob = new Blob([csv], { type: 'text/csv' });
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      // ファイル名の生成
      link.download = `${fileName}`;
      link.click();
    },
  },
};
